import React from 'react';
import { MailX } from 'lucide-react';

/**
 * Where an unsubscribe link lands after it has already worked.
 *
 * <strong>Nothing on this page performs the unsubscribe.</strong> The server did it
 * before it redirected here, on a token and with no session - which is the whole point,
 * since a link clicked out of a mail client arrives with no cookie and cannot rely on
 * anything the portal knows. So this renders outside the logged-in guard, says what has
 * already happened, and is correct even for somebody who has never opened the app in this
 * browser.
 *
 * It says the same thing whether the token matched anybody or not. A stale link from a
 * closed account and a token somebody is guessing at both want this page: the first is a
 * person who wanted mail to stop and already has that, and telling the second they guessed
 * wrong is a distinction they have no business being able to draw.
 */
function UnsubscribedPage({ isLoggedIn, onNavigate }) {
  return (
    <div className="page-container fade-in">
      <div className="auth-card">
        <MailX className="auth-icon" />
        <h1>You are unsubscribed</h1>
        <p className="auth-subtitle">
          We will stop emailing you about invitations, join requests and pick reminders.
        </p>
        <p className="helper-text">
          You will still get the messages you ask for — a password reset, or a link to set
          your password up. Those are not something we can switch off, because an account
          nobody can get back into is worse than an email nobody wanted.
        </p>
        <p className="helper-text">
          Changed your mind, or only want some of them? They are individual switches on
          your profile.
        </p>
        <button
          className="primary-btn full-width"
          onClick={() => onNavigate(isLoggedIn ? 'profile' : 'login')}
        >
          {isLoggedIn ? 'Open my profile' : 'Log in to change these'}
        </button>
      </div>
    </div>
  );
}

export default UnsubscribedPage;
